import React from 'react';
import moment from 'moment';

class footer extends React.Component {
	render () {
		const year = moment().format('YYYY');
		return (
			<footer style={{zIndex:0}}>
				<p>copyright © {year} TSUNAGUTE</p>
			</footer>
		);
	}
}
export default footer;



// WEBPACK FOOTER //
// ./src/common/containers/footer.js